import React, {FC} from 'react';
import Player from '@dazn/lp-web/src/components/VideoPlayer/Player/Player';
import Markdown from 'markdown-to-jsx';
import {
    IPlayerProps,
    IMarkdownContentProps,
    IButtonProps
} from '@dazn/lp-web/src/types';
import {useLandingPagesContext} from '@dazn/lp-web/src/contexts/LandingPageContext';
import styles from '@dazn/lp-web/src/components/VideoPlayer/video-player.module.css';
import {getButtonLabel} from '@dazn/lp-web/src/components/ComingUpRail/comingUp.utils';
import {isPurchased} from './video-player.utils';
import {ComponentTypes} from '../../constants/componentTypes.constants';

const useClassNames = () => {
    return {
        vlpDescription: styles.vlpDescription,
        playerWrapper: styles.playerWrapper,
        playerVideo: styles.playerVideo,
        contentBox: styles.contentBox,
        vlpTitle: styles.vlpTitle,
        button: styles.button
    };
};

export const MarkdownContent: React.FC<IMarkdownContentProps> = ({
    content = '',
    className = '',
    dataTarget = ''
}) => (
    <Markdown
        className={className}
        data-target={dataTarget}
        options={{
            forceBlock: true
        }}
    >
        {content}
    </Markdown>
);

export const Button: React.FC<IButtonProps> = ({label, className, onClick}) => (
    <button className={className} onClick={onClick}>
        {label}
    </button>
);

const VideoPlayer: FC<IPlayerProps> = ({data, index}) => {
    const {
        title = '',
        description = '',
        thumbnail = {},
        videoURL = '',
        badgeText = '',
        button = {},
        entitlementSetId
    } = data || {};

    const {offers} = useLandingPagesContext();
    const buttonLabel = getButtonLabel(
        button,
        offers,
        ComponentTypes.VIDEO_PLAYER
    );
    const classNames = useClassNames();
    const showButton = !isPurchased(entitlementSetId || '');

    const handleButtonClick = () => {
        if (button?.action) {
            button?.action();
        }
    };

    return (
        <div className={classNames.playerWrapper}>
            <div className={classNames.playerVideo}>
                <Player
                    videoUrl={{src: videoURL as string, provider: 'vimeo'}}
                    index={index}
                    thumbnail={thumbnail?.src}
                    trackingSection={'Player'}
                    badgeText={badgeText}
                    entitlementSetId={entitlementSetId}
                />
            </div>
            <div className={classNames.contentBox}>
                {title && (
                    <MarkdownContent
                        content={title}
                        className={classNames.vlpTitle}
                        dataTarget="vlp-title"
                    />
                )}
                {description && (
                    <MarkdownContent
                        content={description}
                        className={classNames.vlpDescription}
                        dataTarget="vlp-description"
                    />
                )}
                {showButton && buttonLabel && (
                    <Button
                        label={buttonLabel}
                        className={classNames.button}
                        onClick={handleButtonClick}
                    />
                )}
            </div>
        </div>
    );
};

export default VideoPlayer;
